import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewRegistroDescuento = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'registro_descuento',
        name: 'Registro Descuento',
        component: ViewRegistroDescuento,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
